import { ArrowIosLeftFill } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { IconButton, Stack, Typography } from '@lyearn/ui';
import Operators from '@/components/Filter/Operators';

import { FilterHeaderProps } from './types';

const FilterHeaderDesktop = (props: FilterHeaderProps) => {
  const { className, label, operators, onBack, labelVariant, operatorsActions } = props;
  const onlyOneOperator = operators && operators.length === 1;

  if (!label && (!operators || onlyOneOperator)) return null;

  return (
    <Stack
      className={cn('border-b border-solid border-interactive-white-hover px-8 py-12', className)}
      direction="col"
      gapY={12}>
      {label ? (
        <Stack alignItems="center" className="overflow-hidden" direction="row">
          {onBack ? (
            <IconButton
              Icon={ArrowIosLeftFill}
              shape="square"
              size="s"
              variant="ghost"
              onClick={onBack}
            />
          ) : null}
          <Typography
            className={cn(onBack ? 'ms-4' : 'mx-12')}
            color={labelVariant === 'caps' ? 'text-text-placeholder' : 'text-text-primary'}
            variant={labelVariant === 'caps' ? 'label-caps' : 'label-02'}>
            {label}
          </Typography>
        </Stack>
      ) : null}
      {operatorsActions && operators?.length ? (
        <Operators
          className=""
          operators={operators}
          selectedOperator={operatorsActions.selectedOperator}
          setFilterOperator={operatorsActions.methods.setSelectedOperator}
        />
      ) : null}
    </Stack>
  );
};

export default FilterHeaderDesktop;
